const OMISE_PAYMENT_RESOLUTION = {
  CONFIRMED: 'confirmed',
  PENDING: 'pending',
  FAILED: 'failed',
};

const OMISE_CHARGE_STATUS = {
  AUTHORIZED: 'authorized',
  PENDING: 'pending',
  FAILED: 'failed',
  SUCCESSFUL: 'successful',
  EXPIRED: 'expired',
  REVERSED: 'reversed',
  CANCELED: 'canceled',
};

const FINAL_FAILED_STATUSES = new Set([
  OMISE_CHARGE_STATUS.FAILED,
  OMISE_CHARGE_STATUS.EXPIRED,
  OMISE_CHARGE_STATUS.REVERSED,
  OMISE_CHARGE_STATUS.CANCELED,
  'cancel',
  'cancelled',
  'voided',
]);

const normalizeStatus = status =>
  String(status || '')
    .trim()
    .toLowerCase();

const hasFailureDetails = charge => !!(charge?.failure_code || charge?.failure_message);

const hasBeenReversed = charge =>
  charge?.reversed === true ||
  charge?.voided === true ||
  normalizeStatus(charge?.status) === OMISE_CHARGE_STATUS.REVERSED;

const getOmiseChargeResolution = charge => {
  const status = normalizeStatus(charge?.status);
  const failureDetails = hasFailureDetails(charge);
  const reversed = hasBeenReversed(charge);

  if (failureDetails || reversed || FINAL_FAILED_STATUSES.has(status)) {
    return {
      resolution: OMISE_PAYMENT_RESOLUTION.FAILED,
      omiseChargeStatus: reversed ? OMISE_CHARGE_STATUS.REVERSED : status || OMISE_CHARGE_STATUS.FAILED,
      paymentStatus: status || OMISE_CHARGE_STATUS.FAILED,
      paymentConfirmed: false,
      shouldConfirmMarketplace: false,
      isFinal: true,
    };
  }

  if (charge?.paid === true || status === OMISE_CHARGE_STATUS.SUCCESSFUL) {
    return {
      resolution: OMISE_PAYMENT_RESOLUTION.CONFIRMED,
      omiseChargeStatus: OMISE_CHARGE_STATUS.SUCCESSFUL,
      paymentStatus: 'paid',
      paymentConfirmed: true,
      shouldConfirmMarketplace: true,
      isFinal: true,
    };
  }

  // For card charges created with capture=false, Omise confirms a valid hold
  // with authorized=true while status can remain "pending" until later capture.
  if (charge?.authorized === true) {
    return {
      resolution: OMISE_PAYMENT_RESOLUTION.CONFIRMED,
      omiseChargeStatus: OMISE_CHARGE_STATUS.AUTHORIZED,
      paymentStatus: OMISE_CHARGE_STATUS.AUTHORIZED,
      paymentConfirmed: true,
      shouldConfirmMarketplace: true,
      isFinal: true,
    };
  }

  return {
    resolution: OMISE_PAYMENT_RESOLUTION.PENDING,
    omiseChargeStatus: status || OMISE_CHARGE_STATUS.PENDING,
    paymentStatus: status || OMISE_CHARGE_STATUS.PENDING,
    paymentConfirmed: false,
    shouldConfirmMarketplace: false,
    isFinal: false,
  };
};

const isOmiseChargeConfirmable = charge =>
  getOmiseChargeResolution(charge).resolution === OMISE_PAYMENT_RESOLUTION.CONFIRMED;

module.exports = {
  OMISE_CHARGE_STATUS,
  OMISE_PAYMENT_RESOLUTION,
  getOmiseChargeResolution,
  isOmiseChargeConfirmable,
};
